import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';

import LoadingComponent from './../../widgets/LoadingComponent';
import { getData, postData } from './../../api/ApiRest';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Modal } from 'react-bootstrap';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import auditoriaSet from '../../widgets/Auditoria';

function Usuarios() {
    const [infoUsuario, setInfoUsuario] = useState({ ModalVisible: false, User: '', Clave: '', Titulo: '', Usuarioid: '', Rollid: '', Activo: true });
    const [rollPermiso, setRollPermiso] = useState([]);
    const [rollPermisoGlobal, setPermisoGlobal] = useState([]);
    const [rollAsignaUsuario, setRollAsignaUsuario] = useState([]);
    const [user, setUsers] = useState([]);
    const [userAnterior, setUserAnterior] = useState([]);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadUsers();
        verPermisosGlobales();

        if (infoUsuario.Usuarioid) {
            verPermisosUsuarios(infoUsuario.Usuarioid);
        }

    }, [infoUsuario.Usuarioid]);

    const loadUsers = () => {
        setLoading(true);

        getData('api/Usuario/UsuariosGet').then(response => {
            setUsers(response.usuarios);
            setUserAnterior(response.usuarios);
            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
            alert('Algo salio mal al cargar los documentos legales');
        })
    }

    ///Función para guardar un nuevo usuario
    const rolSave = () => {
        if (loading) {
            alert('En estos momentos se esta procesando otra solicitud');
            return;
        }

        setLoading(true);

        postData('api/Usuario/crearUsuario', {
            User: infoUsuario.User,
            Clave: infoUsuario.Clave,
            Usuarioid: infoUsuario.Usuarioid || '',
            Activo: infoUsuario.Activo
        }, false).then(response => {
            if (response.status) {
                alert('Usuario modificado con éxito');

                ///Solamente envía el correo cuando es un create
                if (infoUsuario.Titulo === 'Crear usuario')
                    enviaNotificacionUsuario(infoUsuario.User, infoUsuario.Clave);

                ///Agregamos la auditoria correspondiente
                if (infoUsuario.Usuarioid !== '') {
                    const usuarioIni = userAnterior.filter(item => item.id === infoUsuario.Usuarioid)[0];

                    const valueIni = {
                        ModalVisible: false,
                        User: usuarioIni.email,
                        Clave: usuarioIni.contrasena,
                        Titulo: '',
                        Usuarioid: usuarioIni.id,
                        Rollid: '',
                        Activo: usuarioIni.activo
                    };

                    auditoriaSet(valueIni, infoUsuario, 'A', 'Seguridad', usuarioIni.id, 'Usuario');
                } else {
                    auditoriaSet(infoUsuario, {}, 'C', 'Seguridad', infoUsuario.Usuarioid, 'Usuario');
                }

                setInfoUsuario({ ModalVisible: false, User: '', Clave: '', Titulo: '', Usuarioid: '' });
                loadUsers();
            } else {
                alert(response.msj);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para enviar una notificación a un usuario
    const enviaNotificacionUsuario = (usuario, clave) => {
        getData('api/Configuracion/AdminEnvio/notificarCreacionUsuario', {
            correoDestino: usuario,
            clave: clave
        })
    }

    ///Función para agregarle un rol nuevo a un usuario
    const agregarRolUsuario = () => {
        setLoading(true);

        setRollAsignaUsuario([]);

        getData('api/Usuario/guardarRolUsuario', {
            Usuarioid: infoUsuario.Usuarioid,
            Rollid: infoUsuario.Rollid
        }, true).then(response => {
            console.log(response.objectoRoll);
            setRollPermiso(prev => [
                ...prev,
                {
                    rollid: response.objectoRoll[0].rollid,
                    descripcion: response.objectoRoll[0].descripcion
                }
            ]);

            setRollAsignaUsuario(response.rolesMostrar);

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
        })
    }

    ///Función para eliminar un rol especifico de un usuario
    const eliminarPermiso = (Rollid) => {
        setLoading(true);

        getData('api/Usuario/eliminarRolUsuario', {
            Rollid: Rollid,
            Usuarioid: infoUsuario.Usuarioid
        }, false).then(response => {
            if (response.status) {
                alert('Rol eliminado con éxito');
                setRollPermiso(prev => prev.filter(rol => rol.rollid !== Rollid));

                setRollAsignaUsuario(response.rolesMostrar);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para visualizar los roles que han sido asignados a un usuario
    const verPermisosUsuarios = (item) => {
        getData('api/Usuario/getRollCreadosEmpresa', {
            compnayId: 9999,
            usuarioid: item
        }, false).then(response => {
            setRollPermiso(response.rolesTexto);

            const ids = response.rolesTexto.map(r => r.rollid);
            const disponibles = rollPermisoGlobal.filter(rolGlobal => !ids.includes(rolGlobal.rollid));

            setRollAsignaUsuario(disponibles);

            setLoading(false);
        }, error => {
            setLoading(false);
            console.log(error);
        })
    }

    const verPermisosGlobales = () => {
        setLoading(true);

        getData('api/Usuario/getRollCreadosEmpresa', {
            compnayId: 9999,
            usuarioid: ''
        }, false).then(response => {
            setPermisoGlobal(response.permisos);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    return <div className='BodyComponent'>
        <Breadcrumb color='black'>
            <Breadcrumb.Item >Seguridad</Breadcrumb.Item>
            <Breadcrumb.Item active={true}>Usuarios</Breadcrumb.Item>
        </Breadcrumb>

        <Button variant='success'
            onClick={() => setInfoUsuario({ ModalVisible: true, Titulo: 'Crear usuario', User: '', Clave: '', Usuarioid: '' })}
            className='mb-2'>
            <FaPlus size={'1rem'} />
        </Button>

        {<LoadingComponent Loading={loading} />}
        <div className='table-responsive mt-3'>
            <table className='table table-sm table-bordered  table-hover transparentBg'>
                <thead>
                    <tr className='table-info' style={{ fontSize: '14px' }}>
                        <th>#</th>
                        <th>Acciones</th>
                        <th style={{ minWidth: '150px' }}>
                            Usuario
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {user.map((item, key) => {

                        return (
                            <tr key={item.id} style={{ fontSize: '14px' }}>
                                <td className='text-center'>{key + 1}</td>
                                <td className='text-center'>
                                    <Button variant='primary' className='mb-2' onClick={() => {
                                        setRollPermiso([]);

                                        setInfoUsuario({
                                            ModalVisible: true,
                                            User: item.email,
                                            Titulo: 'Editar usuario',
                                            Clave: item.contrasena,
                                            Usuarioid: item.id,
                                            Activo: item.activo
                                        })
                                    }}>
                                        <FaEdit size={'1rem'} />
                                    </Button>
                                </td>
                                <td className='text-center'>
                                    {item.email}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>

        <Modal
            show={infoUsuario.ModalVisible}
            size='xl'
            onHide={() => {
                setInfoUsuario({ ModalVisible: false, User: '', Clave: '', Titulo: '', Usuarioid: '' });

                loadUsers();

                setRollPermiso([]);
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{infoUsuario.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div className='row'>
                    <div className='col-md-4'>
                        <FloatingLabel controlId="usuarioNewInput" label="Usuario">
                            <Form.Control
                                as="input"
                                type='email'
                                placeholder="Ingresa el correo"
                                rows={1}
                                autoComplete='off'
                                value={infoUsuario.User}
                                onChange={event => setInfoUsuario({ ...infoUsuario, User: event.target.value })}
                            />
                        </FloatingLabel>
                    </div>

                    {infoUsuario.Titulo === 'Crear usuario' ?
                        <div className='col-md-4'>
                            <FloatingLabel
                                controlId="UsuarioNewContrasena"
                                label="Contraseña"
                                className='mb-2'
                            >
                                <Form.Control
                                    size='sm'
                                    maxLength={250}
                                    type="text"
                                    required={true}
                                    autoComplete='off'
                                    placeholder="Contraseña"
                                    value={infoUsuario.Clave}
                                    onChange={event => setInfoUsuario({ ...infoUsuario, Clave: event.target.value })}
                                />
                            </FloatingLabel>
                        </div> : null}
                    <div className='col-md-1'>
                        <Form.Check
                            required
                            label="Activo"
                            checked={infoUsuario.Activo}
                            onChange={event => setInfoUsuario({ ...infoUsuario, Activo: event.target.checked })}
                        />
                    </div>
                    <div className='col-md-1'>
                        <Button variant="success" size='sm' type='button' onClick={rolSave}>Guardar</Button>
                    </div>
                </div>

                <br />

                {infoUsuario.Usuarioid ?
                    <div className='row'>
                        <div className='row'>
                            <div className='col-md-4'>
                                <FloatingLabel
                                    controlId='RolNuevoUsuario'
                                    label="Roles"
                                    className="mb-2"
                                >
                                    <Form.Select
                                        value={infoUsuario.Rollid}
                                        onChange={event => {
                                            setInfoUsuario({ ...infoUsuario, Rollid: event.target.value })
                                        }}
                                    >
                                        <option value="">Seleccione</option>
                                        {rollAsignaUsuario.map((item, key) =>
                                            <option key={key} value={item.rollid}>{item.descripcion}</option>)}
                                    </Form.Select>
                                </FloatingLabel>
                            </div>
                            <div className='col-md-1'>
                                <Button variant="primary" size='sm' type='button' onClick={agregarRolUsuario}>
                                    <FaPlus size={'1rem'} />
                                </Button>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='table-responsive mt-2'>
                                <table className='table table-sm table-bordered table-hover'>
                                    <thead>
                                        <tr>
                                            <th>
                                                Acciones
                                            </th>
                                            <th>
                                                Rol
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rollPermiso.map((item, index) => (
                                            <tr key={item.rollid}>
                                                <td className='text-center'>
                                                    <Button variant="danger" size='sm' type='button' onClick={() => eliminarPermiso(item.rollid)}>
                                                        <FaTrash size={'1rem'} />
                                                    </Button>
                                                </td>
                                                <td className='text-center'>
                                                    {item.descripcion}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    : null}

            </Modal.Body>

        </Modal>

    </div>

}


export default Usuarios;